
export interface SupportColors {
    gold: string;
}

export const supportColors: SupportColors = {
    gold : '#eebd20'
};

export interface SupportColors2 {
    orange: string;
    yellowOrange: string;
}

export const supportColors2: SupportColors2 = {
    orange: '#D68119',
    yellowOrange: '#e7b637'
};

export interface CartColors {
    badgeBg: string;
}


export const cartColors: CartColors = {
    badgeBg: supportColors2.yellowOrange
};

export const layout = {
    /*
  Breakpoints from https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/components/layout/doc/index.en-US.md:
  xs: '575px'
  sm: '576px'
  md: '768px'
  lg: '992px'
  xl: '1200px'
  xxl: '1600px'
  */
    desktop: '(min-width: 768px)'
};
